<script>
import ReferralsMixin from './mixins/ReferralsMixin'
import browseMixin from './browse/browseMixin.vue'

export default {
  mixins: [ReferralsMixin, browseMixin],
  data () {
    return {
      logoSource: import.meta.env.VITE_WEBSITE_IMAGES_URL + 'logo.jpg',
    }
  },
}
</script>
